"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_INQUIRIES_PAGINATION = void 0;
exports.DEFAULT_INQUIRIES_PAGINATION = {
    page: 1,
    size: 50,
};
